import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

import { useEffect } from '@wordpress/element';
import metadata from './block.json';
import Style from './Style';

export default function Edit( props ) {
	const { attributes, clientId, setAttributes } = props;
	const { blockId } = attributes;

	useEffect( () => {
		setAttributes( { blockId: clientId } );
	}, [ clientId ] );

	const blockProps = useBlockProps( {
		className: `block-${ blockId ?? 'buttons' }`,
	} );
	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		allowedBlocks: [ 'alpha-blocks/button' ],
		template: [ [ 'alpha-blocks/button' ] ],
		orientation: 'horizontal',
	} );

	return (
		<>
			<window.InspectorGenerator props={ props } blockJson={ metadata } />
			<Style
				attributes={ attributes }
				blockId={ blockId }
				setAttributes={ setAttributes }
			/>
			<div { ...innerBlocksProps } />
		</>
	);
}
